<form action="" class="hidden-form m2" enctype="multipart/form-data" style="display: none;">
  <input #fileUpload type="file" accept=".bib" (change)="onUpload($event)" class="btn" />
</form>

<div class="dca-heading flex items-center justify-between px2" aria-label="reference">
  <div class="h2 flex items-center">
    <span>References</span>
  </div>

  <div class="flex items-center">
    <!-- <button mat-icon-button aria-label="search" (click)="search()">
      <mat-icon>search</mat-icon>
    </button> -->
    <button mat-icon-button matTooltip="Upload bib file" (click)="uploadReferenceFile()">
      <mat-icon>playlist_add</mat-icon>
    </button>
    <!-- <button mat-icon-button matTooltip="Edit References" (click)="editReferences()">
      <mat-icon>edit</mat-icon>
    </button> -->
  </div>
</div>
<div class="flex">
  <div class="flex flex-auto">
    @if (referenceList$ | async; as references) {
      @if (references.length > 0) {
        <div class="reference-list dca-scrollarea flex-column dca-width overflow-y-auto">
          @for (reference of references; track reference.key) {
            <div
              class="citation-card p2 cursor-pointer"
              [ngClass]="{
              'mat-elevation-z1': reference.citationsfromEditor,
              'selected': activeReference() === reference
            }"
              (click)="selectReference(reference)"
            >
              <div class="flex items-center justify-between mxn1">
                <div
                  class="px1 flex"
                  [draggable]="!(isMaximized$() )"
                  [matTooltip]="(isMaximized$() ) ? '' : 'drag reference into document'"
                  (dragstart)="onDragStart($event, reference)"
                >
                  <div class="draggable" [ngClass]="{ 'disabled': (isMaximized$()) }"></div>
                  <div class="ml1">
                    <p class="m0">
                      @if (referenceSourceClass(reference); as sourceClass) {
                        <span
                          class="source-badge"
                          [ngClass]="sourceClass"
                          matTooltip="Detected by AI"
                          aria-label="Detected by AI"
                        ><mat-icon>auto_awesome</mat-icon></span>
                      }
                      {{ reference.bib || (reference | json) }}
                    </p>
                  </div>
                  @if (!isMaximized$() && isReferenceEditingEnabled()) {
                    <div class="flex flex-column justify-center items-center">
                      <button matIconButton (click)="editReference(reference)">
                        <mat-icon>edit</mat-icon>
                      </button>
                    </div>
                  }
                </div>
                <!-- <div class="px1 flex flex-column"> -->
                <!--  <button mat-icon-button aria-label="Calendar">
                <mat-icon>calendar_today</mat-icon>
              </button> -->
                <!-- <button mat-icon-button aria-label="Delete">
                <mat-icon>delete</mat-icon>
              </button> -->
                <!-- </div> -->
              </div>
              @if (reference.citationsfromEditor) {
                <mat-expansion-panel class="mat-elevation-z0 mt2">
                  <mat-expansion-panel-header>
                    <mat-panel-title> Citations in text </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div>
                    <mat-list dense>
                      @for (
                        citations of reference.citationsfromEditor;
                        track citations.id;
                        let i = $index
                      ) {
                        <mat-list-item
                          class="cursor-pointer"
                          (click)="editCitationInText(citations)"
                        >
                          {{ i+1 }}. &nbsp; {{citations.textContent}}
                        </mat-list-item>
                      }
                    </mat-list>
                  </div>
                </mat-expansion-panel>
              }
            </div>
          }
        </div>
      } @else {
        <div class="p2">
          <h3>Upload your references</h3>
          <p>
            The editor is able to format citations automatically when the document is being
            exported. To do that, it needs to learn about your references.
          </p>
          <a (click)="uploadReferenceFile()" class="uppercase">Upload .bib File</a>
          <a href="#" class="ml2 uppercase">Learn more</a>
        </div>
      }
    }

    @if (isMaximized$()) {
      <div class="dca-scrollarea flex flex-column flex-auto items-center">
        @if (activeReference()) {
          <sfo-reference-editor
            [reference]="activeReference()"
            [cslSchemas]="cslSchemas()"
            (updateReference)="updateReference($event)"
          ></sfo-reference-editor>
        } @else {
          <div class="p2">
            <h3>Select a reference to edit</h3>
            <p>
              Click on a reference to view and edit its details. You can also drag and drop a
              reference into the document to create a citation.
            </p>
          </div>
        }
      </div>
    }
  </div>
</div>
